module.exports = __webpack_public_path__ + "img/mob.8a3c863c.svg";